import * as React from 'react';
import * as _ from 'lodash';
import { cleanProps } from '../../../utilities/props';
export default function (props, context) {
    function scopeSelectedPreset1() {
        var selectedPreset = props.selectedPreset || {};
        return React.createElement('div', { 'className': 'app-content-header app-content-header--text app-content-header--lined' }, '\r\n  Select the features that you want to include for the preset \u201C', selectedPreset.name, '\u201D\r\n');
    }
    return scopeSelectedPreset1.apply(this, []);
}